<p-card>
    <ng-template pTemplate="header">
        <h5 class="pdfs-15">Notificaciones</h5>
    </ng-template>
    <h5 class="fs14G">Suscripción por email</h5>
    <div class="mT-15"><p-checkbox inputId="binary"></p-checkbox> <span class="bfs13"> Alerting - <span class="mfs12"> Device alerts in case of operational issues in one or multiple devices.</span></span></div>
    <div class="mT-15"><p-checkbox inputId="binary1"></p-checkbox> <span class="bfs13"> Marketing - <span class="mfs12"> Receive news about offers, discounts and new products.</span></span></div>
    <div class="mT-15"><p-checkbox inputId="binary2"></p-checkbox> <span class="bfs13"> Announcements - <span class="mfs12"> Relevant company announcements, new features and technical updates.</span></span></div>
    <ng-template pTemplate="footer"></ng-template>
</p-card>